import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createIndexedDBStorage from "redux-persist-indexeddb-storage";

import authReducer from './auth-reducer';
import stateReducer from './state-reducer';
import bankDetailReducer from './bank-detail-reducer';
import finyearReducer from './finyear-reducer';
import companyReducer from './company-reducer';
import brokerReducer from './broker-reducer';
import areaReducer from './area-reducer';
import banksReducer from './banks-reducer';
import salesPersonReducer from './sales-person-reducer';
import pipeTypeReducer from './pipe-type-reducer';
import processTypeReducer from './process-type-reducer.js';
import colorReducer from './color-reducer.js';
import scheduleReducer from './schedule-reducer';
import transporterReducer from './transporter-reducer';
// import groupReducer from './group-reducer';
import hsncodeReducer from './hsncode-reducer';
import itemReducer from './item-reducer';
import bobinTypeReducer from './bobin-type-reducer';
import accountReducer from './account-reducer';
import beamReducer from './beam-reducer';
import designReducer from './design-reducer';
import lotReducer from './lot-reducers';
import bookReducer from './book-reducer';
import MachineReducer from './machine-reducer';
import itemLotRateReducer from './item-lot-rate-reducer.js';
import accountItemRateReducer from './account-item-rate-reducer.js';

import productionReducer from './production-entry-reducer';
import productionTransactionReducer from './production-transaction-reducer';
import productionRepackingReducer from './production-repacking-entry-reducer';
import productionRepackingTransactionReducer from './production-repacking-transaction-reducer';
import productionPurchaseReducer from './production-purchase-entry-reducer';
import productionPurchaseTransactionReducer from './production-purchase-transaction-reducer';
import workerReducer from './worker-reducer';
import deliveryChallanReducer from './delivery-challan-reducer';
import salesBillReducer from "./sales-bill-reducer";
import deliveryChallanTransactionReducer from './delivery-challan-transaction-reducer';
import deliveryChallanAvailableTransactionReducer from './delivery-challan-available-transaction-reducer';
import deliveryChallanReturnAvailableTransactionReducer from './delivery-challan-return-available-transaction-reducer';
import userReducer from './user-reducer';
import moduleReducer from './module-reducer';
import rightsReducer from './rights-reducer';
import finyearCompanyReducer from './link-finyear-company-reducer';
import finyearCustomerReducer from './link-finyear-customer-reducer';
import customerReducer from './customer-reducer';
import gradeReducer from './grade-reducer';
import uomReducer from './uom-reducer';
import industryTypeReducer from './industry-type-reducer';
import purchaseChallanReducer from './purchase-challan-reducer';
import purchaseChallanReturnReducer from './purchase-challan-return-reducer';
import purchaseBillReducer from './purchase-bill-reducer';
import purchaseBillReturnReducer from './purchase-bill-return-reducer';
import orderDeliveryScheduleReducer from './order-delivery-schedule-reducer';
import salesReturnReducer from './sales-return-reducer';
import deliveryChallanReturn from './delivery-challan-return-reducer';
import deliveryChallanReturnTransactionReducer from './delivery-challan-return-transaction-reducer';
import generalPurchaseBillReducer from './general-purchase-bill-reducer';
import generalPurchaseReturnBillReducer from './general-purchase-return-bill-reducer';
import tdsSectionReducer from './tds-section-reducer';
import purchaseOrderReducer from './purchase-order-reducer';
import salesOrderReducer from './sales-order-reducer';
import draftCollectionReducer from './draft-collection-reducer.js';
import journalVoucherReducer from './journal-voucher-reducer';
import journalVoucherMultysReducer from './journal-voucher-multy-reducer';
import debitNoteReducer from './debit-note-reducer';
import creditNoteReducer from './credit-note-reducer';
import debitNoteBillBaseReducer from './debit-note-bill-base-reducer';
import creditNoteBillBaseReducer from './credit-note-bill-base-reducer';
import draftDebitNoteBillBaseReducer from './draft-debit-note-bill-base-reducer';
import draftCreditNoteBillBaseReducer from './draft-credit-note-bill-base-reducer';
import debitNoteBillBaseReturnReducer from './debit-note-bill-base-return-reducer';
import creditNoteBillBaseReturnReducer from './credit-note-bill-base-return-reducer';
import bankReceiptReducer from './bank-receipt-reducer';
import bankPaymentReducer from './bank-payment-reducer';
import bankReceiptTransactionReducer from './bank-receipt-transaction-reducer';
import bankPaymentTransactionReducer from './bank-payment-transaction-reducer';
import billAdjustmentReducer from './bill-adjustment-reducer';
import intrestBillAdjustmentReducer from './intrest-bill-adjustment-reducer';
import cashReceiptReducer from './cash-receipt-reducer';
import cashReceiptTransactionReducer from './cash-receipt-transaction-reducer';
import cashPaymentReducer from './cash-payment-reducer';
import cashPaymentTransactionReducer from './cash-payment-transaction-reducer';
import bankReceiptReturnReducer from './bank-receipt-return-reducer';
import bankReceiptReturnTransactionReducer from './bank-receipt-return-transaction-reducer';
import bankPaymentReturnReducer from './bank-payment-return-reducer';
import bankPaymentReturnTransactionReducer from './bank-payment-return-transaction-reducer';
import salesReportReducer from './sales-report-reducer';
import salesReturnReportReducer from './sales-return-report-reducer';
import salesOrderReportReducer from './sales-order-report-reducer';
import purchaseOrderReportReducer from './purchase-order-report-reducer';
import purchaseReturnReportReducer from './purchase-return-report-reducer';
import purchaseReportReducer from './purchase-report-reducer';
import generalPurchaseReportReducer from './general-purchase-report-reducer';
import generalPurchaseReturnReportReducer from './general-purchase-return-report-reducer';
import debitCreditNoteReportReducer from './debit-credit-note-report-reducer';
import debitCreditNoteBillBaseReport from './debit-credit-note-bill-base-report-reducer';
import journalVoucherReportReducer from './journal-voucher-report-reducer';
import salesOutstandingReportReducer from './sales-outstanding-report-reducer';
import generalPurchaseOutstandingReportReducer from './general-purchase-outstanding-report-reducer';
import purchaseOutstandingReportReducer from './purchase-outstanding-report-reducer';
import gstr1ReportReducer from './gstr1-report-reducer';
import gstr2ReportReducer from './gstr2-report-reducer';
import gstr3bReportReducer from './gstr3b-report-reducer';
import gstDetailReportReducer from './gst-detail-report-reducer';
import gstRegisterReportReducer from './gst-register-report-reducer';
import gstr9ReportReducer from './gstr9-report-reducer';
import cancelEWayBillReportReducer from './cancel-eway-bill-report-reduce.js';
import gstRefundReportReducer from './gst-refund-report-reducer';
import purchaseGradeWiseRateDiffReportReducer from './purchase-grade-rate-diff-report-reducer.js';

import unadjustBillSalesReturnReportReducer from './unadjust-bill-sales-return-report-reducer';
import unadjustBillPurchaseReturnReportReducer from './unadjust-bill-purchase-return-report-reducer';
import unadjustBillBankReceiptReportReducer from './unadjust-bill-bank-receipt-report-reducer';
import unadjustBillBankPaymentReportReducer from './unadjust-bill-bank-payment-report-reducer';
import unadjustBillCashReceiptReportReducer from './unadjust-bill-cash-receipt-report-reducer';
import unadjustBillCashPaymentReportReducer from './unadjust-bill-cash-payment-report-reducer';
import unadjustBillDebitNoteReportReducer from './unadjust-bill-debit-note-report-reducer';
import unadjustBillCreditNoteReportReducer from './unadjust-bill-credit-note-report-reducer';
import unadjustBillGeneralPurchaseReturnReportReducer from './unadjust-bill-general-purchase-return-report-reducer';
import bankCashRegisterReportReducer from './bank-cash-register-report-reducer';
import salesInterestCalculationReducer from './sales-interest-calculation-reducer';
import purchaseInterestCalculationReducer from './purchase-interest-calculation-reducer';
import ledgerReportReducer from './ledger-report-reducer';
import bankRecoLedgerReportReducer from './bank-reco-ledger-report-reducer';
import salesPaidBillReportReducer from './sales-paid-bill-report-reducer';
import purchasePaidBillReportReducer from './purchase-paid-bill-report-reducer';

import generalSettingReducer from './general-setting-reducer';

import dashboardReducer from './dashboard-reducer';

import reportMasterReducer from './report-master-reducer';
import reportMasterDetailReducer from './report-master-detail-reducer';

import nonIssueReadyGoodsYarnStockReportReducer from './non-issue-ready-goods-yarn-stock-report-reducer';
import nonIssueReadyGoodsGrayStockReportReducer from './non-issue-ready-goods-gray-stock-report-reducer';
import nonIssueRawMaterialStockReportReducer from './non-issue-raw-material-stock-report-reducer';
import orderBalanceStockReportReducer from './order-balance-stock-report-reducer';
import orderDeliveryScheduleBalanceStockReportReducer from './order-delivery-schedule-balance-stock-report-reducer.js';
import itemLedgerReportReducer from './item-ledger-report-reducer';
import purchaseOrderBalanceStockReportReducer from './purchase-order-balance-stock-report-reducer';
import machineWiseBeamStockReportReducer from './machine-wise-beam-stock-report-reducer.js';
import tdsReportReducer from './tds-report-reducer';
import tcsReportReducer from './tcs-report-reducer';
import ewayBillRechargeReducer from './ewaybill-recharge-reducer';

import lockDataReducer from './lock-data-reducer';
import importDataReducer from './import-data-reducer';
import producitonYarnReportReducer from './production-yarn-report-reducer';
import deliveryChallanYarnReportReducer from './delivery-challan-yarn-report-reducer';
import producitonSizingReportReducer from './production-sizing-report-reducer';
import gnerateTaxJVReducer from './generate-tax-jv-reducer';
import dbBackupReducer from './db-backup-reducer';
import deliveryChallanReturnYarnReportReducer from './delivery-challan-return-yarn-report-reducer';
import jobReducer from './job-reducer';
import vehicleReducer from './vehicle-reducer';
import grayJobIssueReducer from './gray-job-issue-reducer';
import grayJobIssueTransactionReducer from './gray-job-issue-transaction-reducer';

import availableProductionTransactionReducer from './available-production-transaction-reducer';
import producitonGrayReportReducer from './production-gray-report-reducer';
import deliveryChallanGrayReportReducer from './delivery-challan-gray-report-reducer';
import grayJobReceiveReducer from './gray-job-receive-reducer';
import grayJobReceiveTransactionReducer from './gray-job-receive-transaction-reducer';
import grayJobReturnReducer from './gray-job-receive-return-reducer';
import grayJobReturnTransactionReducer from './gray-job-receive-return-transaction-reducer';
import deliveryChallanReturnGrayReportReducer from './delivery-challan-return-gray-report-reducer';
import beamRegisterReportReducer from './beam-register-report-reducer';
import bankSlipEntryReducer from './bank-slip-entry-reducer';
import bankSlipEntryTransactionReducer from './bank-slip-entry-transaction-reducer';
import bankPaymentSlipEntryReducer from './bank-payment-slip-entry-reducer';
import bankPaymentSlipEntryTransactionReducer from './bank-payment-slip-entry-transaction-reducer';

import subJobIssueReducer from './sub-job-issue-reducer';
import subJobIssueTransactionReducer from './sub-job-issue-transaction-reducer';
import subJobReceiveReducer from './sub-job-receive-reducer';
import subJobReceiveTransactionReducer from './sub-job-receive-transaction-reducer';
import subJobReturnReducer from './sub-job-return-reducer';
import subJobReturnTransactionReducer from './sub-job-return-transaction-reducer';
import subJobReceiveGrayReportReducer from './sub-job-pending-receive-gray-report-reducer';
import subJobReceiveYarnReportReducer from './sub-job-pending-receive-yarn-report-reducer';
import branchReducer from './branch-reducer.js';
import productionDetailGrayReportReducer from './production-detial-gray-report-reducer.js';
import productionDetailYarnReportReducer from './production-detial-yarn-report-reducer.js';

import shortExcessReducer from './short-excess-reducer.js';
import workerAverageReducer from './worker-average-reducer.js';
import shortExcessRegisterReportReducer from './short-excess-register-report-reducer';
import workerAttendanceMonthlyReducer from './worker-attendance-monthly-reducer.js';
import workerUpadReducer from './worker-upad-reducer.js';
import workerJamaReducer from './worker-jama-reducer.js';
import workerAttendanceDailyReducer from './worker-attendance-daily-reducer.js';
import karigarSalaryReportReducer from './karigar-salary-report-reducer.js';
import vehicleUpadReducer from './vehicle-upad-reducer.js';
import vehicleSalaryReducer from './vehicle-salary-reducer.js';


import rawMaterialInwardChallanReducer from './raw-material-inward-challan-reducer';
import rawMaterialInwardChallanTransactionReducer from './raw-material-inward-challan-transaction-reducer';

import rawMaterialIssueChallanReducer from './raw-material-issue-challan-reducer';
import rawMaterialIssueChallanTransactionReducer from './raw-material-issue-challan-transaction-reducer';

import rawMaterialReturnChallanReducer from './raw-material-return-challan-reducer';
import rawMaterialReturnChallanTransactionReducer from './raw-material-return-challan-transaction-reducer';

import availableRawMaterialInwardChallanTransactionReducer from './available-raw-material-inward-challan-transaction-reducer';
import masterOptionsReducer from './master-options-reducer';
import mailTemplateReducer from './mail-template-reducer';
import dateWiseProductionReducer from './date-wise-production-reducer';
import dateWiseProductionDifferenceReducer from './date-wise-production-difference-reducer';
import pipeOpeningReducer from './pipe-opening-reducer';
import pipeReceiveReducer from './pipe-receive-reducer';
import pipeReturnReducer from './pipe-return-reducer';
import dateWiseProductionStockReportReducer from './date-wise-production-stock-report-reducer';
import purchaseSaleOrderBalanceReportReducer from './purchase-sale-order-balance-report-reducer';

import whatsappPlanReducer from './whatsapp-plan-reducer';
import whatsappCustomerReducer from './whatsapp-customer-reducer';
import whatsappDeviceReducer from './whatsapp-device-reducer';
import reminderReducer from './reminder-reducer';
import yearEndProcessReducer from './year-end-process-reducer';

import reverseGstChargeReportReducer from './reverse-gst-charge-report-reducer';
import gstLedgerReportReducer from './gst-ledger-report-reducer';
import jobYarnIssueReducer from './job-yarn-issue-reducer';
import jobWorkIssueReducer from './job-work-issue-reducer';
import jobYarnReceiveReducer from './job-yarn-receive-reducer';
import jobYarnReturnReducer from './job-yarn-return-reducer';
import jobYarnStockReportReducer from './job-yarn-stock-report-reducer';
import pipeStockReportReducer from './pipe-stock-report-reducer';
import jobYarnInOutReportReducer from './job-yarn-in-out-report-reducer';
import dateWiseTransactionReportReducer from './date-wise-transaction-report-reducer';
import tableVersionReducer from './table-version-reducer';
import palletReceiveReducer from './pallet-receive-reducer';
import palletIssueReducer from './pallet-issue-reducer';
import palletStockReportReducer from './pallet-stock-report-reducer';
import registerBrokerNotificationsReducer from './register-broker-notifications-reducer';

import sendSMSReducer from './send-sms-reducer';


const indexedDBStorage = createIndexedDBStorage("accountingDB");

const versionPersistConfig = {
  key: 'version',
  storage: storage,
  whitelist: ['tables']
}

const authPersistConfig = {
  key: 'auth',
  storage: storage,
  whitelist: ['token', 'user', 'customer', 'superUser', 'company', 'finyear']
}

const masterPersistConfig = {
  key: 'masters',
  storage: indexedDBStorage,
  whitelist: ['allOptions', 'options', 'isLoaded', 'lastFetchedAt']
}

const settingPersistConfig = {
  key: 'settings',
  storage: storage,
  whitelist: ['generalSetting', 'isLoaded', 'lastFetchedAt']
}

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  version: persistReducer(versionPersistConfig, tableVersionReducer),
  masters: persistReducer(masterPersistConfig, masterOptionsReducer),
  state: stateReducer,
  bankDetail: bankDetailReducer,
  finyear: finyearReducer,
  company: companyReducer,
  broker: brokerReducer,
  area: areaReducer,
  banks: banksReducer,
  salesPersons: salesPersonReducer,
  pipeTypes: pipeTypeReducer,
  colors: colorReducer,
  processTypes: processTypeReducer,
  schedule: scheduleReducer,
  transporter: transporterReducer,
  // group: groupReducer,
  hsnCode: hsncodeReducer,
  item: itemReducer,
  account: accountReducer,
  beam: beamReducer,
  design: designReducer,
  lot: lotReducer,
  book: bookReducer,
  worker: workerReducer,
  user: userReducer,
  module: moduleReducer,
  right: rightsReducer,
  finyearCompany: finyearCompanyReducer,
  finyearCustomer: finyearCustomerReducer,
  customer: customerReducer,
  ewayBillRecharge: ewayBillRechargeReducer,
  whatsappPlan: whatsappPlanReducer,
  whatsappCustomer: whatsappCustomerReducer,
  grade: gradeReducer,
  uom: uomReducer,
  industryType: industryTypeReducer,
  tdsSection: tdsSectionReducer,
  billAdjustment: billAdjustmentReducer,
  intrestBillAdjustment: intrestBillAdjustmentReducer,
  dashboard: dashboardReducer,
  reportMaster: reportMasterReducer,
  reportMasterDetail: reportMasterDetailReducer,
  job: jobReducer,
  vehicle: vehicleReducer,
  machine: MachineReducer,
  branch: branchReducer,
  bobinType: bobinTypeReducer,
  workerAverage: workerAverageReducer,
  workerAttendanceMonthly: workerAttendanceMonthlyReducer,
  workerUpad: workerUpadReducer,
  workerJama: workerJamaReducer,
  workerAttendanceDaily: workerAttendanceDailyReducer,
  vehicleUpad: vehicleUpadReducer,
  vehicleSalary: vehicleSalaryReducer,
  itemLotRate: itemLotRateReducer,
  accountItemRate: accountItemRateReducer,
  inventory: combineReducers({
    production: productionReducer,
    productionTransaction: productionTransactionReducer,
    productionRepacking: productionRepackingReducer,
    productionRepackingTransaction: productionRepackingTransactionReducer,
    productionPurchase: productionPurchaseReducer,
    productionPurchaseTransaction: productionPurchaseTransactionReducer,
    availableProductionTransaction: availableProductionTransactionReducer,
    deliveryChallan: deliveryChallanReducer,
    deliveryChallanTransaction: deliveryChallanTransactionReducer,
    deliveryChallanAvailableTransaction: deliveryChallanAvailableTransactionReducer,
    deliveryChallanReturnAvailableTransaction: deliveryChallanReturnAvailableTransactionReducer,
    deliveryChallanReturn: deliveryChallanReturn,
    deliveryChallanReturnTransaction: deliveryChallanReturnTransactionReducer,
    salesBill: salesBillReducer,
    orderDeliverySchedule: orderDeliveryScheduleReducer,
    purchaseBill: purchaseBillReducer,
    purchaseBillReturn: purchaseBillReturnReducer,
    salesReturn: salesReturnReducer,
    generalPurchaseBill: generalPurchaseBillReducer,
    generalPurchaseReturnBill: generalPurchaseReturnBillReducer,
    purchaseOrder: purchaseOrderReducer,
    salesOrder: salesOrderReducer,
    grayJobIssue: grayJobIssueReducer,
    grayJobIssueTransaction: grayJobIssueTransactionReducer,
    grayJobReceive: grayJobReceiveReducer,
    grayJobReceiveTransaction: grayJobReceiveTransactionReducer,
    grayJobReceiveReturn: grayJobReturnReducer,
    grayJobReceiveReturnTransaction: grayJobReturnTransactionReducer,
    subJobIssue: subJobIssueReducer,
    subJobIssueTransaction: subJobIssueTransactionReducer,
    subJobReceive: subJobReceiveReducer,
    subJobReceiveTransaction: subJobReceiveTransactionReducer,
    subJobReturn: subJobReturnReducer,
    subJobReturnTransaction: subJobReturnTransactionReducer,
    shortExcess: shortExcessReducer,
    rawMaterialInwardChallan: rawMaterialInwardChallanReducer,
    rawMaterialInwardChallanTransaction: rawMaterialInwardChallanTransactionReducer,
    rawMaterialIssueChallan: rawMaterialIssueChallanReducer,
    rawMaterialIssueChallanTransaction: rawMaterialIssueChallanTransactionReducer,
    rawMaterialReturnChallan: rawMaterialReturnChallanReducer,
    rawMaterialReturnChallanTransaction: rawMaterialReturnChallanTransactionReducer,
    availableRawMaterialInwardChallanTransaction: availableRawMaterialInwardChallanTransactionReducer,
    dateWiseProduction: dateWiseProductionReducer,
    dateWiseProductionDifference: dateWiseProductionDifferenceReducer,
    pipeOpening: pipeOpeningReducer,
    pipeReceive: pipeReceiveReducer,
    pipeReturn: pipeReturnReducer,
    jobYarnIssue: jobYarnIssueReducer,
    jobYarnReceive: jobYarnReceiveReducer,
    jobYarnReturn: jobYarnReturnReducer,
    jobWorkIssue: jobWorkIssueReducer,
    palletReceive: palletReceiveReducer,
    palletIssue: palletIssueReducer,
  }),
  transaction: combineReducers({
    purchaseChallan: purchaseChallanReducer,
    purchaseChallanReturn: purchaseChallanReturnReducer,
    journalVoucher: journalVoucherReducer,
    journalVoucherMulty: journalVoucherMultysReducer,
    debitNote: debitNoteReducer,
    creditNote: creditNoteReducer,
    debitNoteBillBase: debitNoteBillBaseReducer,
    creditNoteBillBase: creditNoteBillBaseReducer,
    bankReceipt: bankReceiptReducer,
    bankSlipEntry: bankSlipEntryReducer,
    bankPaymentSlipEntry: bankPaymentSlipEntryReducer,
    bankReceiptTransaction: bankReceiptTransactionReducer,
    bankSlipEntryTransaction: bankSlipEntryTransactionReducer,
    bankPaymentSlipEntryTransaction: bankPaymentSlipEntryTransactionReducer,
    bankPayment: bankPaymentReducer,
    bankPaymentTransaction: bankPaymentTransactionReducer,
    cashReceipt: cashReceiptReducer,
    cashReceiptTransaction: cashReceiptTransactionReducer,
    cashPayment: cashPaymentReducer,
    draftCollection: draftCollectionReducer,
    cashPaymentTransaction: cashPaymentTransactionReducer,
    bankReceiptReturn: bankReceiptReturnReducer,
    bankReceiptReturnTransaction: bankReceiptReturnTransactionReducer,
    bankPaymentReturn: bankPaymentReturnReducer,
    bankPaymentReturnTransaction: bankPaymentReturnTransactionReducer,
    debitNoteBillBaseReturn: debitNoteBillBaseReturnReducer,
    creditNoteBillBaseReturn: creditNoteBillBaseReturnReducer,
    purchaseGradeWiseRateDiffReport: purchaseGradeWiseRateDiffReportReducer,
  }),
  report: combineReducers({
    saleReport: salesReportReducer,
    saleReturnReport: salesReturnReportReducer,
    saleOrderReport: salesOrderReportReducer,
    purchaseReturnReport: purchaseReturnReportReducer,
    purchaseReport: purchaseReportReducer,
    debitCreditNoteReport: debitCreditNoteReportReducer,
    debitCreditNoteBillBaseReport: debitCreditNoteBillBaseReport,
    purchaseOrderReport: purchaseOrderReportReducer,
    generalPurchaseReport: generalPurchaseReportReducer,
    generalPurchaseReturnReport: generalPurchaseReturnReportReducer,
    journalVoucherReport: journalVoucherReportReducer,
    saleOutstandingReport: salesOutstandingReportReducer,
    generalPurchaseOutstandingReport: generalPurchaseOutstandingReportReducer,
    unadjustBillSalesReturnReport: unadjustBillSalesReturnReportReducer,
    unadjustBillPurchaseReturnReport: unadjustBillPurchaseReturnReportReducer,
    unadjustBillBankReceiptReport: unadjustBillBankReceiptReportReducer,
    unadjustBillBankPaymentReport: unadjustBillBankPaymentReportReducer,
    unadjustBillCashReceiptReport: unadjustBillCashReceiptReportReducer,
    unadjustBillCashPaymentReport: unadjustBillCashPaymentReportReducer,
    unadjustBillDebitNoteReport: unadjustBillDebitNoteReportReducer,
    unadjustBillCreditNoteReport: unadjustBillCreditNoteReportReducer,
    unadjustBillGeneralPurchaseReturnReport: unadjustBillGeneralPurchaseReturnReportReducer,
    bankCashRegisterReport: bankCashRegisterReportReducer,
    ledgerReport: ledgerReportReducer,
    bankRecoLedgerReport: bankRecoLedgerReportReducer,
    purchaseOutstandingReport: purchaseOutstandingReportReducer,
    gstr1Report: gstr1ReportReducer,
    gstr2Report: gstr2ReportReducer,
    gstr3bReport: gstr3bReportReducer,
    gstDetailReport: gstDetailReportReducer,
    salesInterestCalculation: salesInterestCalculationReducer,
    purchaseInterestCalculation: purchaseInterestCalculationReducer,
    salesPaidBillReport: salesPaidBillReportReducer,
    purchasePaidBillReport: purchasePaidBillReportReducer,
    gstRegisterReport: gstRegisterReportReducer,
    nonIssueReadyGoodsYarnStockReport: nonIssueReadyGoodsYarnStockReportReducer,
    nonIssueReadyGoodsGrayStockReport: nonIssueReadyGoodsGrayStockReportReducer,
    nonIssueRawMaterialStockReport: nonIssueRawMaterialStockReportReducer,
    gstr9Report: gstr9ReportReducer,
    gstRefundReport: gstRefundReportReducer,
    orderBalanceStockReport: orderBalanceStockReportReducer,
    orderDeliveryScheduleBalanceStockReport: orderDeliveryScheduleBalanceStockReportReducer,
    itemLedgerReport: itemLedgerReportReducer,
    tdsReport: tdsReportReducer,
    tcsReport: tcsReportReducer,
    purchaseOrderBalanceStockReport: purchaseOrderBalanceStockReportReducer,
    productionYarnReport: producitonYarnReportReducer,
    deliveryChallanYarnReport: deliveryChallanYarnReportReducer,
    deliveryChallanReturnYarnReport: deliveryChallanReturnYarnReportReducer,
    productionSizingReport: producitonSizingReportReducer,
    productionGrayReport: producitonGrayReportReducer,
    deliveryChallanGrayReport: deliveryChallanGrayReportReducer,
    deliveryChallanReturnGrayReport: deliveryChallanReturnGrayReportReducer,
    beamRegisterReport: beamRegisterReportReducer,
    subJobPendingReceiveGrayReport: subJobReceiveGrayReportReducer,
    subJobPendingReceiveYarnReport: subJobReceiveYarnReportReducer,
    cancelEWayBillReport: cancelEWayBillReportReducer,
    machineWisebeamStockReport: machineWiseBeamStockReportReducer,
    productionDetailGrayReport: productionDetailGrayReportReducer,
    productionDetailYarnReport: productionDetailYarnReportReducer,
    shortExcessRegisterReport: shortExcessRegisterReportReducer,
    karigarSalaryReport: karigarSalaryReportReducer,
    dateWiseProductionStockReport: dateWiseProductionStockReportReducer,
    purchaseSaleOrderBalanceReport: purchaseSaleOrderBalanceReportReducer,
    reverseGstChargeReport: reverseGstChargeReportReducer,
    gstLedgerReport: gstLedgerReportReducer,
    jobYarnStockReport: jobYarnStockReportReducer,
    jobYarnInOutReport: jobYarnInOutReportReducer,
    pipeStockReport: pipeStockReportReducer,
    dateWiseTransactionReport: dateWiseTransactionReportReducer,
    palletStockReport: palletStockReportReducer,
  }),
  settings: persistReducer(settingPersistConfig, generalSettingReducer),
  utility: combineReducers({
    lockData: lockDataReducer,
    importData: importDataReducer,
    taxJV: gnerateTaxJVReducer,
    whatsappDevice: whatsappDeviceReducer,
    dbBackup: dbBackupReducer,
    reminder: reminderReducer,
    yearEndProcess: yearEndProcessReducer,
  }),
  others: combineReducers({
    mailTemplate: mailTemplateReducer,
    sendSMS: sendSMSReducer,
  }),
  draft: combineReducers({
    draftDebitNoteBillBase: draftDebitNoteBillBaseReducer,
    draftCreditNoteBillBase: draftCreditNoteBillBaseReducer,
  }),
  notifications: combineReducers({
    registerBrokerNotification: registerBrokerNotificationsReducer,
  }),
});

export default rootReducer;
